<fcom-modal
  [(open)]="modalOpen"
  [title]="'safNotification.infoModal.title' | finLocalization"
  [buttons]="ModalButtons.CLOSE"
  (close)="closeModal.emit()"
>
  <ng-container *ngIf="safArticle$ | async as article">
    <div data-testid="sustainability-image" class="image-wrapper relative flex" *ngIf="article.picture as imageData">
      <fin-content-image [imageData$]="imageData | finToObservable" [aspectRatio$]="aspectRatio$" />
    </div>

    <cms-rich-text
      [attr.data-testid]="'item-teaser-title-' + article.contentId"
      [extraClasses]="'font-body-2 mr-large-b ' + article.subjectTaxonomyTags?.join(' ')"
      [headerLevel]="4"
      [scaleImage]="false"
      [content$]="safArticle$"
    />
  </ng-container>
</fcom-modal>
